module.exports = __webpack_public_path__ + "static/media/video-revision-es.92d98961.vtt";